import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QRCodeModule } from 'angularx-qrcode';
import { Crisp } from 'crisp-sdk-web';
import { SharedModule } from 'src/app/modules/shared/shared.module';

@Component({
  selector: 'app-qrcode',
  standalone: true,
  imports: [QRCodeModule, SharedModule],
  templateUrl: './qrcode.component.html',
  styleUrl: './qrcode.component.scss',
})
export class QrcodeComponent implements OnInit {
  route = inject(ActivatedRoute);
  qrdata: string;
  ngOnInit(): void {
    Crisp.chat.hide();
    this.route.queryParams.subscribe((params) => {
      if (params['code']) {
        this.qrdata = params['code'];
      }
    });
  }
}
